<template>
  <div class="wc-configured-product-section-rows">
    <h1 ref="focusFirst" class="sr-only">{{ name }} {{ t('homePage') }}</h1>
    <template v-for="row in rows" :key="row.id">
      <WCProductRowModern :rowId="row.id" :rowName="row.name" />
    </template>
    <WCCouponRowModern
      v-if="$configuration.allowCouponClipping && !hideCoupons"
      class="my-md-3"
      :key="'coupon:homepage'"
    />
  </div>
</template>

<script setup lang="ts">
import { defineProps, withDefaults } from 'vue';
import { useI18n } from 'vue-i18n';
import WCProductRowModern from '@/components/WCProductRow/WCProductRowModern.vue';
import WCCouponRowModern from '@/components/WCCouponRow/WCCouponRowModern.vue';

interface ConfiguredRow {
  id: string;
  name: string;
}

interface Props {
  name: string;
  rows?: ConfiguredRow[];
  hideCoupons?: boolean;
}

withDefaults(defineProps<Props>(), {
  rows: () => [],
  hideCoupons: false,
});

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.wc-configured-product-section-rows {
  :deep(.item-row .product-row-class-desktop),
  :deep(.item-row .coupon-row-class-desktop) {
    padding: 0 2rem;
  }
}
</style>
